var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 33,
    rx: 4.5,
    fill: "#594AD7",
    stroke: "#272727"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4 19.5107V5.1C19.4 4.8082 19.5156 4.52871 19.7218 4.3225C19.928 4.11626 20.2085 4 20.5 4C20.7916 4 21.072 4.11626 21.2782 4.3225C21.4845 4.52874 21.6 4.80823 21.6 5.1V19.5107C21.6 19.5107 23.699 17.4123 24.8759 16.2353C25.0824 16.0291 25.3619 15.913 25.6537 15.913C25.9452 15.913 26.2254 16.0291 26.4316 16.2353C26.8613 16.665 26.8613 17.3614 26.4316 17.7911L21.2363 22.9864C21.041 23.1817 20.776 23.2917 20.5 23.2917C20.224 23.2917 19.9589 23.1817 19.7636 22.9864L14.5683 17.7911C14.1386 17.3614 14.1386 16.665 14.5683 16.2353C14.7745 16.0291 15.0547 15.913 15.3463 15.913C15.6381 15.913 15.9176 16.0291 16.124 16.2353C17.301 17.4123 19.3999 19.5107 19.3999 19.5107H19.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 26.9167C33 27.4694 32.7807 27.999 32.3896 28.3896C31.999 28.7807 31.4693 29 30.9167 29H10.0833C9.53064 29 9.00095 28.7807 8.61036 28.3896C8.21927 27.999 8 27.4693 8 26.9167V20.6107C8 20.0034 8.4927 19.5107 9.1 19.5107H9.10046C9.39227 19.5107 9.67176 19.627 9.87796 19.8332C10.0842 20.0394 10.2005 20.3192 10.2005 20.6107V25.7577C10.2005 26.3332 10.6667 26.7993 11.2421 26.7993H29.7576C30.3331 26.7993 30.7993 26.3332 30.7993 25.7577V20.6107C30.7993 20.3191 30.9155 20.0394 31.1218 19.8332C31.328 19.627 31.6075 19.5107 31.8993 19.5107H31.8997C32.5071 19.5107 32.9997 20.0034 32.9997 20.6107V26.9167H33Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTransaction);
export default __webpack_public_path__ + "static/media/download_transaction.c72c29a9c71bcf5a3dbe65a63301c75e.svg";
export { ForwardRef as ReactComponent };